<template>
    <div>
        <div class="table-wrapper">
            <table id="edit_media_table" class="cic-table">
                <thead>
                    <tr>
                        <th style="width: 40px"></th>
                        <th>{{ $t('Media') }}</th>
                        <th style="width: 80px">{{ $t('Media Type') }}</th>
                        <th v-if="!orgList && $store.hasRight('bDeleteMedia')" style="width: 40px; text-align: center">
                            {{ $t('Delete') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in media" @click="(evt) => handleClick(evt, row.id)">
                        <td :class="'media-icon media-icon-' + row.type"></td>
                        <td>{{ row.name }}</td>
                        <td>{{ $t('MEDIA_TYPE_' + row.type) }}</td>
                        <td v-if="!orgList && $store.hasRight('bDeleteMedia')">
                            <IconButton icon="remove-icon" @click="handleDelete(row)" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <template v-if="item">
            <div class="cic-header">
                <span class="cic-header-title">{{ $t('Edit Media') }}</span>
            </div>
            <ul class="item-form">
                <li class="form-label-first">{{ $t('Media Name') }}</li>
                <li>
                    <CicTextbox
                        id="media_name"
                        :value="item.name"
                        :enabled="$store.hasRight('bEditMedia')"
                        @input="(val) => (item.name = val)"
                    />
                </li>
                <li>
                    <div class="media-progress">
                        <ElProgress
                            v-if="item.type === 1 && !disableStreaming"
                            :percentage="progress === 0 ? 1 : progress"
                            :show-text="false"
                        />
                    </div>
                </li>
            </ul>
        </template>
        <div class="cic-footer">
            <template v-if="item">
                <CicButton v-if="$store.hasRight('bEditMedia')" id="media_save" @click="handleSave">
                    {{ $t('Save') }}
                </CicButton>
                <CicButton id="media_cancel" @click="handleCancel">{{ $t('Cancel') }}</CicButton>
                <template v-if="item.type === 1 && !disableStreaming">
                    <CicButton v-if="progress === 0" id="media_play" @click="handlePlay">{{ $t('Play') }}</CicButton>
                    <CicButton v-else id="media_stop" @click="handleStop">{{ $t('Stop') }}</CicButton>
                    <audio
                        v-if="url"
                        ref="audioplay"
                        controls
                        preload="none"
                        style="display: none"
                        @ended="handleEnded"
                        @timeupdate="handleUpdate"
                    >
                        <source :src="`data:audio/mpeg;base64,${url}`" />
                    </audio>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
    import { ElProgress } from 'element-plus';
    import CicButton from '@/components/CicButton';
    import IconButton from '@/components/controls/IconButton';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import loadMedia from './MediaUtils';

    export default {
        name: 'EditMedia',
        components: {
            CicButton,
            CicTextbox,
            IconButton,
            ElProgress,
        },
        props: {
            disableStreaming: {
                type: Boolean,
                default: false,
            },
            media: {
                type: Array,
                required: true,
            },
            mediaListId: {
                type: Number,
                required: true,
            },
            orgList: {
                type: Boolean,
                default: false,
            },
        },
        emits: ['change'],
        data() {
            return {
                item: null,
                progress: 0,
                url: null,
            };
        },
        methods: {
            handleCancel() {
                this.handleStop();
                this.item = null;
                this.url = null;
            },
            handleClick(evt, mediaId) {
                if (
                    !this.orgList &&
                    (evt.target.classList.length === 0 || !['icon'].some((x) => evt.target.classList.contains(x)))
                ) {
                    this.handleCancel();
                    this.item = { ...this.media.find((x) => x.id === mediaId) };
                }
            },
            handleDelete(media) {
                if (confirm(this.$t('Are you sure you wish to delete [x]?').replace(/\[x]/g, media.name))) {
                    this.handleCancel();
                    loadMedia('media/delete', { mediaListId: this.mediaListId, mediaId: media.id }, 'right', () => {
                        this.$emit('change');
                    });
                }
            },
            handleEnded() {
                this.progress = 0;
            },
            handlePlay() {
                if (this.url) {
                    this.$refs.audioplay.play();
                } else {
                    loadMedia(
                        'media/play',
                        { mediaListId: this.mediaListId, mediaId: this.item.id },
                        '',
                        (response) => {
                            this.url = response.url;
                            this.$nextTick(() => {
                                this.$refs.audioplay.play();
                            });
                        },
                    );
                }
            },
            handleSave() {
                if (confirm(this.$t('Are you sure you wish update this media?'))) {
                    this.handleStop();
                    loadMedia(
                        'media/update',
                        {
                            mediaListId: this.mediaListId,
                            mediaId: this.item.id,
                            name: this.item.name,
                        },
                        'right',
                        () => {
                            this.handleCancel();
                            this.$emit('change');
                        },
                    );
                }
            },
            handleStop() {
                if (this.$refs.audioplay && this.$refs.audioplay.ended === false) {
                    this.$refs.audioplay.pause();
                    this.$refs.audioplay.currentTime = 0;
                    this.progress = 0;
                }
            },
            handleUpdate(evt) {
                this.progress = Math.min((evt.target.currentTime * 100) / evt.target.duration, 100);
            },
        },
    };
</script>
